import {Box, Container, GlobalStyles, useTheme} from "@mui/material";
import React from "react";
import Logo from "../../assets/img/logo_ata.png";


const BoxedLayout = ({children}) => {
  const theme = useTheme();

  return (
    <React.Fragment>
      <GlobalStyles
        styles={{body: {backgroundColor: theme.palette.background.paper}}}
      />
      <Container
        component="main"
        maxWidth="xs"
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img src={Logo} alt="Logo" width={150} height={70} />

          {children}
        </Box>
      </Container>
    </React.Fragment>
  );
};

export default BoxedLayout;
